<template>
  <ZigzagServiceLayout
    mainTitle="Harmonização Facial e Injetáveis"
    mainDescription="Redescubra o seu brilho. Nossos tratamentos injetáveis especializados e preenchimentos são projetados para ajudar a reduzir a aparência de linhas finas, restaurar o volume e realçar os seus traços."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'FacialHarmonizationContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ANTI-ENVELHECIMENTO',
          title: 'Tratamentos Injetáveis',
          subtitle: 'Projetados para ajudar a reduzir a aparência de linhas finas.',
          paragraphs: [
            "Os tratamentos injetáveis oferecem uma abordagem minimamente invasiva projetada para ajudar a reduzir a aparência de rugas dinâmicas causadas por movimentos faciais.",
            "Ao direcionar áreas específicas, esses tratamentos podem ajudar a suavizar pés de galinha e linhas da testa, deixando você com uma aparência revigorada e descansada."
          ],
          list: [
            "Procedimento rápido e minimamente invasivo",
            "Aponta para linhas de expressão e rugas",
            "Os resultados geralmente duram de 3 a 4 meses",
            "Projetado para ajudar a reduzir a aparência de linhas mais profundas"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/dsy8tUMNyIs',
            'https://www.youtube.com/embed/LM2IEIQ-mC8'
          ]
        },
        {
          label: 'VOLUME E CONTORNO',
          title: 'Preenchedores Dérmicos',
          subtitle: 'Restaure o volume perdido e melhore os contornos.',
          paragraphs: [
            "Com o envelhecimento, nossa pele perde sustentação e volume. Os preenchimentos usam ácido hialurônico para preencher maravilhosamente a pele por baixo.",
            "Se você deseja realçar os lábios, definir as maçãs do rosto ou preencher as dobras profundas ao redor da boca, os preenchimentos proporcionam lifting imediato."
          ],
          list: [
            "Restaura o volume jovem nas bochechas e nos lábios",
            "Suaviza linhas profundas e dobras da face",
            "Resultados imediatos, visíveis e naturais",
            "Os efeitos podem durar de 6 a 18 meses"
          ],
          image: '/images/services/facial-harm.png'
        }
      ]
    };
  }
};
</script>
